import util from '@bmp-vue/core/api/util'
const controller = 'pesado'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get (th) {
    const anoInicio = th.$param.AnoFim_Inicio.anoInicio
    const anoFim = th.$param.AnoFim_Inicio.anoFim
    const tabela = th.$param.TabelaTaxas.map(l => {
      if (l.ano[0] === 'anoInicio') {
        l.ano[0] = anoInicio
      } else if (l.ano[0] === 'anoFim') {
        l.ano[0] = anoFim
      }
      return l
    })
    return tabela
  },
  GetItem (modeloAno, tipoParcela, th) {
    let retorno = {}
    if (modeloAno <= th.$param.AnoFim_Inicio.anoInicio) {
      retorno = ctrl.Get(th).find(item => item.ano === th.$param.AnoFim_Inicio.anoInicio).tabela.find(itemTabela => itemTabela.tipoParcela === tipoParcela)
    } else if (modeloAno >= th.$param.AnoFim_Inicio.anoFim) {
      retorno = ctrl.Get(th).find(item => item.ano >= th.$param.AnoFim_Inicio.anoFim).tabela.find(itemTabela => itemTabela.tipoParcela === tipoParcela)
    } else {
      retorno = ctrl.Get(th).find(item => { return item.ano[0] <= modeloAno && item.ano[1] >= modeloAno }).tabela.find(itemTabela => itemTabela.tipoParcela === tipoParcela)
    }
    return retorno
  },
  ValidaVlrEntradaByTipoVeiculo (th) {
    var vlrMinEntrada;
    if (th.model.PropostaDadosVeiculo.TipoPlaca === th.$aux.TipoPlacaEnum.Caminhao) {
      if (th.model.PropostaDadosVeiculo.AnoFab && th.model.Parcelas) {
        vlrMinEntrada = ctrl.GetItem(th.model.PropostaDadosVeiculo.AnoFab, th.model.Parcelas, th).minEntrada
        return th.model.VlrEntrada >= (th.model.VlrProdutoBem * vlrMinEntrada).toFixed(2) || 'O Valor da Entrada deve ser pelo menos ' + (vlrMinEntrada * 100) + '% do Valor do Veículo'
      }
    } else {
      vlrMinEntrada = 0.2
      return th.model.VlrEntrada >= (th.model.VlrProdutoBem * vlrMinEntrada).toFixed(2) || 'O Valor da Entrada deve ser pelo menos ' + (vlrMinEntrada * 100) + '% do Valor do Veículo'
    }
  },
  GetTaxa (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.PropostaDadosVeiculo.AnoMod, th.model.Parcelas, th)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.InsertCCBDigitalAssinatura(request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
  },
  CarregaDiasAcrescimo (th, value) {
    if (value && !ctrl.AllowedDates(th, value)) {
      let date = new Date(value)
      date = th.$api.UI.Date.AddDay(date, 1).toISOString().substr(0, 10)
      th.$set(th.model, 'DtPrimeiroVencto', date)
      th.carregaDiasAcrescimo(date)
      return
    }
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), value)
  },
  AllowedDates (th, value) {
    return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
  },
  TipoErroGravameEnum: {
    Externo: 1,
    Interno: 2
  },
})

export default ctrl
